/* cb-compare.js - verschillen, beste waarde en selectie op de vergelijkpagina
 *
 * Hoort bij sections/cb-compare.liquid. Wat dit script NIET doet: de lijst
 * bijhouden. Welke producten er in de vergelijking zitten regelt custom.js
 * samen met de EcomRise-app; het verwijderen van een kolom gaat via het
 * <hdt-compare>-element en de klasse hdt-compare-item-<id>. Zie de comment-kop
 * van de sectie.
 *
 * Hier gebeurt drie dingen:
 *   - rijen waarvan elke zichtbare kolom hetzelfde zegt wegfilteren
 *   - per rij de beste waarde markeren
 *   - producten selecteren en in een keer in de winkelwagen leggen
 */
(function () {
  var root = document.querySelector('[data-cb-compare]');
  if (!root) { return; }

  var table = root.querySelector('[data-cb-table]');
  if (!table) { return; }

  var bar = root.querySelector('[data-cb-bar]');
  var barCount = root.querySelector('[data-cb-bar-count]');
  var barTotal = root.querySelector('[data-cb-bar-total]');

  var state = { diff: false, best: true, selected: [] };

  function columns() {
    return Array.prototype.slice.call(root.querySelectorAll('[data-cb-col]'));
  }

  /* Bedragen via het money_format van de winkel, nooit via Intl. Shopify
     groepeert in al zijn varianten per drie cijfers. */
  function money(cents) {
    var format = root.getAttribute('data-money-format') || '{{amount}}';
    var fixed = (cents / 100).toFixed(2);
    var whole = fixed.split('.')[0];
    var decimals = fixed.split('.')[1];

    function group(separator) {
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    }

    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, group('.'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, group('.') + ',' + decimals)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, group("'") + '.' + decimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, group(','))
      .replace(/\{\{\s*amount\s*\}\}/g, group(',') + '.' + decimals);
  }

  function render() {
    var live = columns().map(function (cell) { return cell.getAttribute('data-cb-col'); });

    Array.prototype.forEach.call(root.querySelectorAll('[data-cb-row]'), function (row) {
      var cells = Array.prototype.slice.call(row.querySelectorAll('[data-cb-value]'))
        .filter(function (cell) { return live.indexOf(cell.getAttribute('data-col')) > -1; });

      /* Vergelijken gebeurt op wat er staat, niet op de ruwe waarde: dat is wat
         de bezoeker ziet. Bij één kolom is niets gelijk. */
      var texts = cells.map(function (cell) {
        return cell.querySelector('.cb-cmp__value').textContent.trim();
      });
      var same = cells.length > 1 && texts.every(function (text) { return text === texts[0]; });

      row.classList.toggle('is-same', same);
      row.hidden = state.diff && same;

      cells.forEach(function (cell) { cell.classList.remove('is-best'); });
      Array.prototype.forEach.call(row.querySelectorAll('.cb-cmp__best'), function (mark) {
        mark.hidden = true;
      });

      var better = row.getAttribute('data-better');
      if (!state.best || better === 'none' || same || cells.length < 2) { return; }

      var numbers = cells
        .map(function (cell) { return parseFloat(cell.getAttribute('data-number')); })
        .filter(function (value) { return !isNaN(value); });
      if (numbers.length < 2) { return; }

      var target = better === 'high' ? Math.max.apply(null, numbers) : Math.min.apply(null, numbers);
      for (var index = 0; index < cells.length; index += 1) {
        if (parseFloat(cells[index].getAttribute('data-number')) === target) {
          cells[index].classList.add('is-best');
          var mark = cells[index].querySelector('.cb-cmp__best');
          if (mark) { mark.hidden = false; }
          break;
        }
      }
    });

    /* De selectie kan kolommen bevatten die intussen verwijderd zijn. */
    state.selected = state.selected.filter(function (id) { return live.indexOf(id) > -1; });

    var chosen = columns().filter(function (cell) {
      return state.selected.indexOf(cell.getAttribute('data-cb-col')) > -1;
    });
    var total = chosen.reduce(function (sum, cell) {
      return sum + (parseInt(cell.getAttribute('data-price'), 10) || 0);
    }, 0);

    if (barCount) {
      barCount.textContent = (root.getAttribute('data-count-template') || '[n] / [total]')
        .replace('[n]', chosen.length)
        .replace('[total]', live.length);
    }
    if (barTotal) { barTotal.textContent = money(total); }
    if (bar) { bar.hidden = chosen.length === 0; }
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-cb-toggle]'), function (button) {
    button.addEventListener('click', function () {
      var key = button.getAttribute('data-cb-toggle');
      state[key] = !state[key];
      button.classList.toggle('is-on', state[key]);
      button.setAttribute('aria-pressed', state[key] ? 'true' : 'false');
      render();
    });
  });

  function setSelected(id, on) {
    var index = state.selected.indexOf(id);
    if (on && index === -1) { state.selected.push(id); }
    if (!on && index > -1) { state.selected.splice(index, 1); }

    var button = root.querySelector('[data-cb-select="' + id + '"]');
    if (button) {
      button.classList.toggle('is-on', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      button.textContent = on ? root.getAttribute('data-added-label') : button.getAttribute('data-label');
    }
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-cb-select]'), function (button) {
    button.addEventListener('click', function () {
      var id = button.getAttribute('data-cb-select');
      setSelected(id, state.selected.indexOf(id) === -1);
      render();
    });
  });

  var selectAll = root.querySelector('[data-cb-select-all]');
  selectAll && selectAll.addEventListener('click', function () {
    columns().forEach(function (cell) {
      if (cell.getAttribute('data-available') !== '1') { return; }
      setSelected(cell.getAttribute('data-cb-col'), true);
    });
    render();
  });

  var cart = root.querySelector('[data-cb-cart]');
  cart && cart.addEventListener('click', function () {
    var chosen = columns().filter(function (cell) {
      return state.selected.indexOf(cell.getAttribute('data-cb-col')) > -1
        && cell.getAttribute('data-available') === '1'
        && cell.getAttribute('data-variant') !== '0';
    });
    if (chosen.length === 0) { return; }

    cart.disabled = true;
    var routes = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(routes + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: chosen.map(function (cell) {
          return { id: parseInt(cell.getAttribute('data-variant'), 10), quantity: 1 };
        })
      })
    }).then(function (response) {
      if (!response.ok) { throw new Error('cart'); }
      window.location.href = routes + 'cart';
    }).catch(function () {
      cart.disabled = false;
      cart.textContent = cart.getAttribute('data-label');
    });
  });

  /* Wissen leegt dezelfde opslag die custom.js gebruikt en gaat daarna naar de
     lege vergelijkpagina. Voor ingelogde klanten zit de lijst in het metafield
     van de app; die haalt hij bij het laden opnieuw op. */
  var clear = root.querySelector('[data-cb-clear]');
  clear && clear.addEventListener('click', function () {
    try { localStorage.removeItem(root.getAttribute('data-storage-key')); } catch (error) { /* niets */ }
    window.location.href = root.getAttribute('data-empty-url');
  });

  var share = root.querySelector('[data-cb-share]');
  if (share && navigator.clipboard) {
    var shareLabel = share.textContent;
    share.addEventListener('click', function () {
      navigator.clipboard.writeText(window.location.href).then(function () {
        share.textContent = root.getAttribute('data-copied-label');
        share.classList.add('is-done');
        setTimeout(function () {
          share.textContent = shareLabel;
          share.classList.remove('is-done');
        }, 1600);
      });
    });
  } else if (share) {
    share.hidden = true;
  }

  /* custom.js haalt bij het verwijderen de cellen zelf uit de DOM. Daarna
     kloppen "gelijk", "beste" en het totaal niet meer, dus opnieuw tekenen
     zodra er iets uit de tabel verdwijnt. */
  if (window.MutationObserver) {
    var observer = new MutationObserver(function (records) {
      var gone = records.some(function (record) { return record.removedNodes.length > 0; });
      if (gone) { render(); }
    });
    observer.observe(table, { childList: true, subtree: true });
  }

  render();
})();
